import { ChevronDown } from "lucide-react";
import { useI18n } from "../i18n";
import { TopographicLines } from "./TopographicLines";

export function Faq() {
  const { messages } = useI18n();

  return (
    <section className="faq section" aria-labelledby="faq-title">
      <TopographicLines className="faq__contours" />
      <div className="shell faq__grid">
        <h2 id="faq-title">{messages.faq.title}</h2>
        <div className="faq__list">
          {messages.faq.items.map((item, index) => (
            <details key={item.question} open={index === 0}>
              <summary>
                <span>{item.question}</span>
                <ChevronDown size={20} aria-hidden="true" />
              </summary>
              <p>{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
